import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TargetsSliceObject {
  month: number; // 1-12
  year: number; // YYYY
  amount: number | null; // KES
  loading: boolean;
  error?: string | null;
}

const now = new Date();
const initialState: TargetsSliceObject = {
  month: now.getMonth() + 1,
  year: now.getFullYear(),
  amount: null,
  loading: false,
  error: null,
};

const targetsSlice = createSlice({
  name: 'backofficeTargets',
  initialState,
  reducers: {
    setTargetContext: (
      state,
      action: PayloadAction<{ month: number; year: number }>,
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    setTargetLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTargetError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTargetAmount: (state, action: PayloadAction<number | null>) => {
      state.amount = action.payload;
    },
  },
});

export const {
  setTargetContext,
  setTargetLoading,
  setTargetError,
  setTargetAmount,
} = targetsSlice.actions;

export default targetsSlice.reducer;
